<template>
  <fragment>
    <header class="site-header">
      <div class="container">
        <div class="site-header-inner">
          <c-logo />
          <button
            v-if="!hideNav"
            ref="hamburger"
            class="header-nav-toggle"
            aria-controls="primary-menu"
            :aria-expanded="isActive ? 'true' : 'false'"
            @click="isActive ? closeMenu() : openMenu()"
          >
            <span class="screen-reader">{{ $t("site.nav.menu") }}</span>
            <span class="hamburger">
              <span class="hamburger-inner"></span>
            </span>
          </button>
          <nav
            v-if="!hideNav"
            ref="nav"
            class="header-nav"
            :class="{ 'is-active': isActive }"
          >
            <div class="header-nav-inner">
              <ul class="list-reset text-xs right header-nav-right">
                <li @click="isActive ? closeMenu() : openMenu()">
                  <router-link to="/">{{
                    $t("site.nav.forEmployers")
                  }}</router-link>
                </li>
                <li @click="isActive ? closeMenu() : openMenu()">
                  <router-link to="/student">{{
                    $t("site.nav.forStudents")
                  }}</router-link>
                </li>
                <li @click="isActive ? closeMenu() : openMenu()">
                  <router-link to="/about/">{{
                    $t("site.nav.about")
                  }}</router-link>
                </li>
              </ul>
            </div>
          </nav>
          <div class="locale-changer">
            <select v-on:change="changeLanguage(currentLanguage, $event)">
              <option
                v-for="(lang, i) in langs"
                :key="`Lang${i}`"
                :value="lang"
                :v-model="currentLanguage"
                :selected="lang == currentLanguage"
                >{{ lang }}</option
              >
            </select>
          </div>
        </div>
      </div>
    </header>
    <main class="site-content">
      <slot />
    </main>
    <c-footer />
  </fragment>
</template>

<script>
import CFooter from "@/components/layout/Footer.vue";
import CLogo from "@/components/layout/partials/LogoInvert.vue";

export default {
  components: {
    CFooter,
    CLogo,
  },
  data() {
    return {
      isActive: this.active || false,
      hideNav: false,
      langs: ["🇺🇸", "🇩🇪"],
      currentLanguage: "🇩🇪",
    };
  },
  methods: {
    openMenu() {
      document.body.classList.add("off-nav-is-active");
      if (this.$refs.nav)
        this.$refs.nav.style.maxHeight = this.$refs.nav.scrollHeight + "px";
      this.$emit("update:active", true);
      this.isActive = true;
    },
    closeMenu() {
      document.body.classList.remove("off-nav-is-active");
      if (this.$refs.nav) this.$refs.nav.style.maxHeight = null;
      this.$emit("close");
      this.$emit("update:active", false);
      this.isActive = false;
    },
    keyPress() {
      this.isActive && event.keyCode === 27 && this.closeMenu();
    },
    clickOutside(e) {
      if (!this.$refs.nav) return;
      if (
        !this.isActive ||
        this.$refs.nav.contains(e.target) ||
        e.target === this.$refs.hamburger
      )
        return;
      this.closeMenu();
    },
    changeLanguage: function changeLanguage(currentLanguage, event) {
      if (event.target.value == "🇩🇪") {
        this.$i18n.locale = "de";
      } else {
        this.$i18n.locale = "en";
      }
    },
  },
  mounted() {
    this.active && this.openMenu();
    document.addEventListener("keydown", this.keyPress);
    document.addEventListener("click", this.clickOutside);
    // init browser language
    var language = window.navigator.userLanguage || window.navigator.language;
    if (language.includes("de")) {
      this.$i18n.locale = "de";
      this.currentLanguage = "🇩🇪";
    } else {
      this.$i18n.locale = "en";
      this.currentLanguage = "🇺🇸";
    }
  },
  beforeDestroy() {
    document.addEventListener("keydown", this.keyPress);
    document.removeEventListener("click", this.clickOutside);
  },
};
</script>

<style lang="scss" scoped>
.header-nav-toggle + .header-nav {
  background: #fff;
}
.header-nav-toggle + .header-nav ul {
  a:not(.button) {
    color: #95a4b4;
  }
  a:not(.button):hover,
  a:not(.button):active {
    color: #212121 !important;
  }
}
.router-link-exact-active {
  color: #212121 !important;
}
select {
  background-color: #fff !important;
}
</style>
